import { render, staticRenderFns } from "./Pensione.vue?vue&type=template&id=525643da&scoped=true&"
import script from "./Pensione.vue?vue&type=script&lang=js&"
export * from "./Pensione.vue?vue&type=script&lang=js&"
import style0 from "./Pensione.vue?vue&type=style&index=0&id=525643da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525643da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
